module.exports = __webpack_public_path__ + "media/images/crosspoint_icon-525b3c0ba82babf4d8a2f05e0bd80ca9.svg";